import React, { useMemo } from "react";

import { useParams } from "next/navigation";

import { GlobalPathParams } from "~/app/[locale]/types";
import { CombinedButton } from "~/components/combined-button/component";
import { Routes } from "~/constants/request";
import { encodeStoreAddress } from "~/helpers/encode-store-address";
import { getLinkUrl } from "~/helpers/locales";
import { getTestAutomationProps } from "~/helpers/test-automation-props";

import { StoreCard, StoreCardProps } from "../store-card/component";

import { LINKED_STORE_CARD_CLASSES } from "./constants";
import { LinkedStoreCardContainer } from "./styled";

export const LinkedStoreCard: React.FC<StoreCardProps> = ({
  store,
  storeOpenText,
  storeClosedText,
}) => {
  const { locale } = useParams<GlobalPathParams>();
  const address = [store?.address.line1, store?.address.line2, store?.address.city]
    .filter((i) => i)
    .map(encodeStoreAddress);
  const url = useMemo(
    () =>
      getLinkUrl(
        locale,
        `${Routes.STORES_SEARCH}/${address[address.length - 1]}/${address[0]}`,
      ),
    [locale, address],
  );
  return (
    <LinkedStoreCardContainer {...getTestAutomationProps("store-link")}>
      <CombinedButton
        href={url}
        fullWidth
        variant="outlined"
        classes={{
          root: `${LINKED_STORE_CARD_CLASSES.button} ${LINKED_STORE_CARD_CLASSES.buttonLabel}`,
        }}
      >
        <StoreCard
          className={LINKED_STORE_CARD_CLASSES.storeCard}
          store={store}
          storeOpenText={storeOpenText}
          storeClosedText={storeClosedText}
        />
      </CombinedButton>
    </LinkedStoreCardContainer>
  );
};
